import { render, staticRenderFns } from "./Fundraisers.vue?vue&type=template&id=453c52d8&"
import script from "./Fundraisers.vue?vue&type=script&lang=js&"
export * from "./Fundraisers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports